import React from 'react';

import { chartCreateTrigger } from '@gogame/components';

const triggers = {};

const useTrigger = (id) => {
  React.useEffect(() => {
    return () => {
      delete triggers[id];
    };
  }, []);

  if (triggers[id]) {
    return triggers[id];
  }

  const trigger = chartCreateTrigger();

  triggers[id] = trigger;

  return trigger;
};

export default useTrigger;
